export const getDateForReactDatepicker = (passedDate) => {
  if (passedDate === null || passedDate === '') {
    return null;
  }
  if (typeof passedDate === 'string') {
    return new Date(passedDate);
  }
  return passedDate;
};
